import {
  BoxConnectionItem,
  BoxDetailStatusProps,
  BoxVersionItem
} from '@/box/interface'
import { connectionModeItems } from '@/shared/SelectData'
import { connectionState } from '@/shared/Status'
import { getFormatMessage } from '@/utils/utils'
import { Descriptions } from 'antd'
import React from 'react'

export const BoxDetailStatus: React.FC<BoxDetailStatusProps> = (
  props: BoxDetailStatusProps
) => {
  const { detailItem } = props
  const formatMessage = getFormatMessage()

  const formatConnState = (state?: number) => {
    return state !== undefined ? connectionState[state!].text : '-'
  }

  const formatVersion = (ver?: BoxVersionItem) => {
    if (ver && ver.fcs && ver.fds && ver.floader) {
      return `${ver.fcs}.${ver.fds}.${ver.floader}`
    }
    return '-'
  }

  const formatMode = (conn?: BoxConnectionItem) => {
    if (conn && conn.mode) {
      return connectionModeItems.find((x) => x.value === conn.mode)?.text
    }
    return '-'
  }

  const formatBoxType = (boxType?: number, subType?: number) => {
    if (boxType !== undefined && subType !== undefined) {
      if (subType !== 1) {
        return (
          formatValue('app.boxType', boxType) +
          '-' +
          formatValue('app.subType', subType)
        )
      }
      return formatValue('app.boxType', boxType)
    }
    return '-'
  }

  const formatValue = (key: string, value?: any) => {
    if (value !== undefined) {
      return formatMessage({ id: `${key}.${value}` })
    }
    return '-'
  }

  const formatEmpty = (msg?: string) => {
    if (msg && msg !== '0') return msg
    return '-'
  }

  return (
    <div>
      <Descriptions
        title={formatMessage({ id: 'app.box.detail.status.basicInfo' })}
      >
        <Descriptions.Item
          label={formatMessage({ id: 'app.box.detail.status.connectionState' })}
        >
          {formatConnState(detailItem?.connectionState)}
        </Descriptions.Item>
        <Descriptions.Item
          label={formatMessage({ id: 'app.box.detail.status.networkType' })}
        >
          {formatValue('app.networkType', detailItem?.currentNetwork)}
        </Descriptions.Item>
        <Descriptions.Item
          label={formatMessage({ id: 'app.box.detail.status.boxType' })}
        >
          {formatBoxType(detailItem?.boxType, detailItem?.subType)}
        </Descriptions.Item>
        <Descriptions.Item
          label={formatMessage({ id: 'app.box.detail.status.softVer' })}
        >
          {formatVersion(detailItem?.softVer)}
        </Descriptions.Item>
        <Descriptions.Item
          label={formatMessage({ id: 'app.box.detail.status.boxNo' })}
        >
          {formatEmpty(detailItem?.boxNo)}
        </Descriptions.Item>
        <Descriptions.Item
          label={formatMessage({ id: 'app.box.detail.status.userPassword' })}
        >
          {formatEmpty(detailItem?.userPassword)}
        </Descriptions.Item>
        <Descriptions.Item
          label={formatMessage({ id: 'app.box.detail.status.connection' })}
        >
          {formatMode(detailItem?.connection)}
        </Descriptions.Item>
      </Descriptions>

      <Descriptions title={formatMessage({ id: 'app.box.detail.status.wan' })}>
        <Descriptions.Item
          label={formatMessage({ id: 'app.box.detail.status.ipAddr' })}
        >
          {formatEmpty(detailItem?.wan?.ipAddr)}
        </Descriptions.Item>
        <Descriptions.Item
          label={formatMessage({ id: 'app.box.detail.status.subnetMask' })}
        >
          {formatEmpty(detailItem?.wan?.subnetMask)}
        </Descriptions.Item>
        <Descriptions.Item
          label={formatMessage({ id: 'app.box.detail.status.gateway' })}
        >
          {formatEmpty(detailItem?.wan?.gateway)}
        </Descriptions.Item>
        <Descriptions.Item
          label={formatMessage({ id: 'app.box.detail.status.dns1' })}
        >
          {formatEmpty(detailItem?.wan?.dns1)}
        </Descriptions.Item>
        <Descriptions.Item
          label={formatMessage({ id: 'app.box.detail.status.dns2' })}
        >
          {formatEmpty(detailItem?.wan?.dns2)}
        </Descriptions.Item>
        <Descriptions.Item
          label={formatMessage({ id: 'app.box.detail.status.lanIp' })}
        >
          {formatEmpty(detailItem?.wan?.lanIp)}
        </Descriptions.Item>
      </Descriptions>
      <Descriptions title={formatMessage({ id: 'app.box.detail.status.gprs' })}>
        <Descriptions.Item
          label={formatMessage({ id: 'app.box.detail.status.ipAddr' })}
        >
          {formatEmpty(detailItem?.gprs?.ipAddr)}
        </Descriptions.Item>
        <Descriptions.Item
          label={formatMessage({ id: 'app.box.detail.status.subnetMask' })}
        >
          {formatEmpty(detailItem?.gprs?.subnetMask)}
        </Descriptions.Item>
        <Descriptions.Item
          label={formatMessage({ id: 'app.box.detail.status.gateway' })}
        >
          {formatEmpty(detailItem?.gprs?.gateway)}
        </Descriptions.Item>
        <Descriptions.Item
          label={formatMessage({ id: 'app.box.detail.status.dns1' })}
        >
          {formatEmpty(detailItem?.gprs?.dns1)}
        </Descriptions.Item>
        <Descriptions.Item
          label={formatMessage({ id: 'app.box.detail.status.dns2' })}
        >
          {formatEmpty(detailItem?.gprs?.dns2)}
        </Descriptions.Item>
      </Descriptions>
      <Descriptions title={formatMessage({ id: 'app.box.detail.status.wifi' })}>
        <Descriptions.Item
          label={formatMessage({ id: 'app.box.detail.status.ipAddr' })}
        >
          {formatEmpty(detailItem?.wifi?.ipAddr)}
        </Descriptions.Item>
        <Descriptions.Item
          label={formatMessage({ id: 'app.box.detail.status.subnetMask' })}
        >
          {formatEmpty(detailItem?.wifi?.subnetMask)}
        </Descriptions.Item>
        <Descriptions.Item
          label={formatMessage({ id: 'app.box.detail.status.gateway' })}
        >
          {formatEmpty(detailItem?.wifi?.gateway)}
        </Descriptions.Item>
        <Descriptions.Item
          label={formatMessage({ id: 'app.box.detail.status.dns1' })}
        >
          {formatEmpty(detailItem?.wifi?.dns1)}
        </Descriptions.Item>
        <Descriptions.Item
          label={formatMessage({ id: 'app.box.detail.status.dns2' })}
        >
          {formatEmpty(detailItem?.wifi?.dns2)}
        </Descriptions.Item>
      </Descriptions>
      <Descriptions
        title={formatMessage({ id: 'app.box.detail.status.version' })}
      >
        <Descriptions.Item
          label={formatMessage({ id: 'app.box.detail.status.hardware' })}
        >
          {formatEmpty(detailItem?.softVer?.hardware)}
        </Descriptions.Item>
        <Descriptions.Item
          label={formatMessage({ id: 'app.box.detail.status.fcs' })}
        >
          {formatEmpty(detailItem?.softVer?.fcs)}
        </Descriptions.Item>
        <Descriptions.Item
          label={formatMessage({ id: 'app.box.detail.status.boot' })}
        >
          {formatEmpty(detailItem?.softVer?.boot)}
        </Descriptions.Item>
        <Descriptions.Item
          label={formatMessage({ id: 'app.box.detail.status.fds' })}
        >
          {formatEmpty(detailItem?.softVer?.fds)}
        </Descriptions.Item>
        <Descriptions.Item
          label={formatMessage({ id: 'app.box.detail.status.kernel' })}
        >
          {formatEmpty(detailItem?.softVer?.kernel)}
        </Descriptions.Item>
        <Descriptions.Item
          label={formatMessage({ id: 'app.box.detail.status.fgui' })}
        >
          {formatEmpty(detailItem?.softVer?.fgui)}
        </Descriptions.Item>
        <Descriptions.Item
          label={formatMessage({ id: 'app.box.detail.status.rootfs' })}
        >
          {formatEmpty(detailItem?.softVer?.rootfs)}
        </Descriptions.Item>
        <Descriptions.Item
          label={formatMessage({ id: 'app.box.detail.status.floader' })}
        >
          {formatEmpty(detailItem?.softVer?.floader)}
        </Descriptions.Item>
      </Descriptions>
    </div>
  )
}
